export default __webpack_public_path__ + "static/media/displaySlider.1f71e57b.png";